// src/components/common/DeleteConfirmModal.jsx
// -----------------------------------------------------------------------------
// Confirmation modal component for delete operations.
// Shows explicit confirmation message, warnings, and handles submitting state.
// -----------------------------------------------------------------------------
import PropTypes from 'prop-types';
import Modal from './Modal';
import './common.css';

export default function DeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Delete',
  itemLabel = 'this record',
  deleting = false,
}) {
  if (!isOpen) return null;

  return (
    <Modal title={title} onClose={onClose}>
      <div className="modal-delete-body">
        <p className="modal-delete-text">
          Are you sure you want to delete <strong>{itemLabel}</strong>? This action cannot be undone.
        </p>

        <div className="modal-delete-actions">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
            disabled={deleting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={onConfirm}
            disabled={deleting}
          >
            {deleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </Modal>
  );
}

DeleteConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  itemLabel: PropTypes.string,
  deleting: PropTypes.bool,
};
